<mat-form-field class="default-field-width" [formGroup]="form" appearance="fill">
  <mat-label>{{ placeholder }}</mat-label>
  <mat-select [formControlName]="controlName">
    <mat-option [value]="RegionType.MARKET_AREA" [disabled]="!isMarketAreaAvailable">
      {{ 'DROPDOWN.MARKET_AREA' | translate }}
    </mat-option>
    <!-- <mat-option [value]="RegionType.TRADE_AREA">{{ 'DROPDOWN.TRADE_AREA' | translate }}</mat-option> -->
    <mat-option [value]="RegionType.DRIVE_TIME">
      {{ 'DROPDOWN.DRIVE_TIME' | translate }}
    </mat-option>
    <mat-option [value]="RegionType.RING">
      {{ 'DROPDOWN.RING' | translate }}
    </mat-option>
  </mat-select>
</mat-form-field>
